import Link from "Components/UI/Link/Link";
import React from "react";
import { useNavigate } from "react-router";
import styles from "../InputSearch.module.scss";
import { TRecords } from "Shared/Types/globalSearch";
import { useGlobalSearchResults } from "./useGlobalSearch";

type SearchResultProps = {
  onClose: () => void;
  searchValue: string | undefined;
};

const SearchResult: React.FC<SearchResultProps> = ({ searchValue }) => {
  const { isAllEmpty, categories } = useGlobalSearchResults();
  const navigate = useNavigate();

  const isHave = (records?: TRecords[]) => records && records.length > 0;

  const highlightText = (text: string, searchTerm: string) => {
    if (!searchTerm) return text;
    const regex = new RegExp(`(${searchTerm})`, "gi");
    return text.replace(
      regex,
      (match) => `<span style="color:#5b90c2;">${match}</span>`
    );
  };
  if (!searchValue || isAllEmpty) {
    return (
      <div className={styles.modal}>
        <h4>Nothing was found for your request</h4>
      </div>
    );
  }

  return (
    <div className={styles.modal}>
      {categories.map((el, index) => {
        if (!isHave(el.records)) return null;
        return (
          <div key={index}>
            <h4>{el.title}</h4>
            {el.records?.map((item, idx) => (
              <div
                key={idx}
                onClick={() => navigate(item.detail_route)}
                className={styles.box}
              >
                <span>-</span>
                {item.desc.map((val, id) => (
                  <span
                    key={id}
                    dangerouslySetInnerHTML={{
                      __html: highlightText(val.toString(), searchValue || ""),
                    }}
                  />
                ))}
              </div>
            ))}
            <div className={styles.moreLink}>
              <Link to={el.list_route}>More</Link>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SearchResult;
